import React, {useEffect, useReducer} from 'react';
import {ModalHeader, ModalBody} from 'reactstrap';
import {useTranslation} from 'react-i18next';

import * as apis from '@/b2b/apis';

import reducer, {getInitialState} from '@/b2b/pages/PolicyStatement/state';
import {PolicyStatementCtx} from '@/b2b/contexts';

import Header from '@/b2b/pages/PolicyStatement/Header';
import InnerHtml from '@/b2b/pages/PolicyStatement/InnerHtml';
import styles from '@/b2b/index.module.css';

const PolicyStatementContext = ({partyId, children}) => {
  const [state, dispatch] = useReducer(reducer, getInitialState(partyId));

  useEffect(() => {
    apis.policyList(partyId).then(res => {
      dispatch({type: 'updateStatementInfo', payload: res.data});
    });
  }, []);

  return (
    <PolicyStatementCtx.Provider value={[state, dispatch]}>
      {children}
    </PolicyStatementCtx.Provider>
  );
};

const PolicyStatement = ({handleClick, partyId}) => {
  const {t: tr} = useTranslation('nb');
  const closeBtn = (
    <span
      role='button'
      tabIndex={0}
      className={styles.modal_close}
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      &times;
    </span>
  );

  return (
    <PolicyStatementContext partyId={partyId}>
      <ModalHeader
        toggle={handleClick}
        close={closeBtn}
        className={styles.modal_header}
      >
        {tr('statement')}
      </ModalHeader>
      <ModalBody>
        <Header />
        <InnerHtml />
      </ModalBody>
    </PolicyStatementContext>
  );
};

export default PolicyStatement;
